/**
 * Lightweight lazysizes replacement (P1-1).
 * - Unveils img[data-srcset]/[data-src].lazyload → real src/srcset
 * - Unveils .lazyload[data-bgset] → background-image (incl. media | syntax)
 * - Watches dynamically inserted nodes (cart, swatches, section AJAX)
 */
(function () {
  if (window.__babeinaNativeLazy) return;
  window.__babeinaNativeLazy = true;

  function pickUrlFromSrcset(srcset, targetW) {
    if (!srcset) return '';
    var candidates = srcset.split(',').map(function (part) {
      var bits = part.trim().split(/\s+/);
      return { url: bits[0], w: parseInt(bits[1], 10) || 0 };
    }).filter(function (c) { return c.url; });
    if (!candidates.length) return '';
    var best = candidates[0];
    for (var i = 0; i < candidates.length; i++) {
      best = candidates[i];
      if (candidates[i].w >= targetW) break;
    }
    return best.url;
  }

  function resolveBgset(raw) {
    if (!raw) return '';
    var parts = raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    var chosen = parts[parts.length - 1] || '';
    var w = window.innerWidth || 1200;
    for (var i = 0; i < parts.length; i++) {
      var m = parts[i].match(/\[\s*max-width:\s*(\d+)px\s*\]/i);
      if (m && w <= parseInt(m[1], 10)) {
        chosen = parts[i];
        break;
      }
    }
    chosen = chosen.replace(/\s*\[[^\]]*\]\s*/g, '').trim();
    var target = w * (window.devicePixelRatio || 1);
    return pickUrlFromSrcset(chosen, target) || chosen.split(/\s+/)[0] || '';
  }

  function unveil(el) {
    if (!el || el.classList.contains('lazyloaded')) return;

    if (el.tagName === 'IMG') {
      var srcset = el.getAttribute('data-srcset');
      var dataSrc = el.getAttribute('data-src');
      if (srcset) {
        el.setAttribute('srcset', srcset);
        el.removeAttribute('data-srcset');
      }
      if (dataSrc) {
        el.setAttribute('src', dataSrc);
        el.removeAttribute('data-src');
      } else if (srcset) {
        var fallback = pickUrlFromSrcset(srcset, (window.innerWidth || 800) * (window.devicePixelRatio || 1));
        if (fallback) el.setAttribute('src', fallback);
      }
      if (!el.getAttribute('loading')) el.setAttribute('loading', 'lazy');
      if (!el.getAttribute('decoding')) el.setAttribute('decoding', 'async');
    } else if (el.hasAttribute('data-bgset')) {
      var url = resolveBgset(el.getAttribute('data-bgset'));
      if (url) {
        el.style.backgroundImage = 'url("' + url.replace(/"/g, '\\"') + '")';
        el.setAttribute('data-bg-url', url);
      }
      // Keep data-bgset so UI that swaps backgrounds (custom dropdowns) can re-apply.
    }

    el.classList.remove('lazyload');
    el.classList.add('lazyloaded');
    if (window.ioNativeLazy) window.ioNativeLazy.unobserve(el);
  }

  function isLazyTarget(el) {
    if (!el || el.nodeType !== 1) return false;
    if (!el.classList.contains('lazyload')) return false;
    if (el.tagName === 'IMG') {
      return el.hasAttribute('data-srcset') || el.hasAttribute('data-src');
    }
    return el.hasAttribute('data-bgset');
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        unveil(entry.target);
      }
    });
  }, { rootMargin: '400px 0px', threshold: 0.01 });
  window.ioNativeLazy = io;

  function observe(el) {
    if (!isLazyTarget(el) || el.__nativeLazyObserved) return;
    el.__nativeLazyObserved = true;
    io.observe(el);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (isLazyTarget(scope)) observe(scope);
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('img.lazyload[data-srcset], img.lazyload[data-src], .lazyload[data-bgset]').forEach(observe);
  }

  function boot() {
    scan(document);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (isLazyTarget(n)) observe(n);
          else scan(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Compat for code that re-triggers lazysizes by toggling classes
  window.babeinaUnveilLazy = unveil;
})();
